<!-- CONTENT 1: ELEGIR OPCIONES -->
<div class="container">
  <div class="row">
    <!-- BLOQUE 1 -->
    <div class="col-12 offset-md-1 col-md-10 noEstar">
      <div *ngIf="business" style="height: 40px;"></div>
      <h3 *ngIf="!business" [innerHtml]="'Home.NotHomeInfo' | translate" class="titH3"
        style="padding-left:10px;padding-right:10px;"></h3>
      <div class="well" style="border:none;box-shadow:none;margin-bottom:0;">
        <div class="row">
          <div class="col-12">
            <form class="form-inline row" autocomplete="on" id="busqueda" (ngSubmit)="searchExpedition()">
              <div class="col-12 col-md-3 offset-md-2">
                <h4 style="text-align:right;position: relative; top: 8px;"
                  [innerHtml]="'Home.TrackParcelInfo' | translate"></h4>
              </div>
              <div class="col-12 col-md-4">
                <div class="input-group-text" style="background-color: transparent;border: none;padding: 0 1px 0 1px;">
                  <input name="expeditionNumber" [(ngModel)]="expeditionNumber" [regexReplace]="regexExpedition"
                    type="text" class="form-control" [placeholder]="'Shared.ShipmentNumberInput' | translate "
                    maxlength="39">
                  <span class="input-group-btn" style="margin-bottom: 0.5rem; width: max-content;">
                    <button class="btn" id="search" style="height: 37px; width: 40px; border-radius: 0px 5px 5px 0px;">
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="business" class="emptyBlock"></div>
  <div *ngIf="!business" class="container elegirOpciones" class="row">
    <div class="">
      <!-- BLOQUE 1 -->
      <div class="col-12 offset-md-2 col-md-8 txtOpciones">
        <p [innerHtml]="'Home.ShipmentWhenInfo' | translate"></p>
      </div>
      <!-- BLOQUE OPCIONES -->
      <div class="bloqueOpciones col-12 row noPLPR">
        <div class="col-12 col-sm-4 opciones">
          <div class="iconOpcion">
            <img src="{{directoryImages}}/assets/images/Preferred_date_230415.jpg" alt="">
          </div>
          <div class="txtOpciones">
            <h4 class="opcionTitle">{{'Home.ChangeDeliveryDate' | translate}}</h4>
            <p [innerHtml]="'Home.ChangeDateInfo' | translate"></p>
          </div>
        </div>

        <div class="col-12 col-sm-4 opciones">
          <div class="iconOpcion">
            <img src="{{directoryImages}}/assets/images/Rerouting.jpg" alt="">
          </div>
          <div class="txtOpciones">
            <h4 class="opcionTitle">{{'Home.DeliveryServicePoint' | translate}}</h4>
            <p [innerHtml]="'Home.ServicePointInfo' | translate"></p>
          </div>
        </div>

        <div class="col-12 col-sm-4 opciones">
          <div class="iconOpcion">
            <img src="{{directoryImages}}/assets/images/Delivery_situation_230415.jpg" alt="">
          </div>
          <div class="txtOpciones">
            <h4 class="opcionTitle">{{'Home.NeighbourDelivery' | translate}}</h4>
            <p [innerHtml]="'Home.NeighbourInfo' | translate"></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CONTENT 3: CONTACTO -->
  <div *ngIf="!business" class="container moduloContacto" class="row">
    <div style="margin-right:0;margin-left:0;">
      <div class="row col-12 offset-md-2 col-md-8 txtOpciones">
        <p style="font-weight:bold;">{{'Shared.TextContact1' | translate}}
          <br />{{'Shared.TextContact2' | translate}}
        </p>
      </div>
      <div class="row col-12 offset-sm-4 col-sm-4 btnSentStatus d-grid">
        <a [href]="'Shared.RouteUrlContact' | translate"
          (click)="sesion.enviarEventoGoogleAnalitics(categoriasGoogleAnalytics.Otros, 'Contacto' );" target="_blank"
          type="" class="btn btn-default btn-block" style="width: -webkit-fill-available;">{{'Shared.Contact' |
          translate}}</a>
      </div>
    </div>
  </div>

</div>